module.exports = __webpack_public_path__ + "h5/img/live-logo.808c9f7d.jpeg";